import React from 'react';
import { graphql } from 'gatsby';
import {
  StyledDependableSendingBlock
} from './styles';
import SendGridLink from '../../SendGridLink';

const GlobalContentBlocksDependableSendingBlock = ({ block }) => {
  return (
      <StyledDependableSendingBlock>
        {console.log(block)}
        <div className="dependable-block--text">
          <div className="dependable-block--inner">
            <h2>{block.headline}</h2>
            <h3>{block.subheadline}</h3>
            <p dangerouslySetInnerHTML={{ __html: block.mainText }} />
            <SendGridLink
              href={block.ctaLink}
              className="arrow-link"
            >
              {block.ctaText}
            </SendGridLink>
          </div>
        </div>
        <img className="dependable-block--image" src={block.image.sourceUrl} />
        <div className="dependable-block--stats-wrapper">
          {block.stats.map((stat) => (
            <div className="dependable-block--stat">
              <h2 dangerouslySetInnerHTML={{ __html: stat.number }} />
              <p dangerouslySetInnerHTML={{ __html: stat.description }} />
            </div>
          ))}
        </div>
      </StyledDependableSendingBlock>
  );
};

export default GlobalContentBlocksDependableSendingBlock;

export const query = graphql`
  fragment DependableSendingBlockFragment on WPGraphQL_Page {
    acfGlobalContentBlocks {
      contentBlocks {
        ... on WPGraphQL_Page_Acfglobalcontentblocks_ContentBlocks_DependableSendingBlock {
          fieldGroupName
          headline
          subheadline
          mainText
          ctaText
          ctaLink
          image {
            sourceUrl
          }
          stats {
            fieldGroupName
						number
            description
          }
        }
      }
    }
  }
`;
